import emailjs from '@emailjs/browser';

// Email service utility for handling contact form submissions
// Using EmailJS for real email delivery

interface ContactFormData {
  name: string;
  phone: string;
  email: string;
  organization: string;
}

interface EmailServiceConfig {
  subject: string;
  formData: ContactFormData;
}

export const sendContactFormEmail = async (config: EmailServiceConfig): Promise<boolean> => {
  try {
    console.log('=== EMAIL SERVICE DEBUG START ===');
    console.log('Subject:', config.subject);
    console.log('Form data:', config.formData);
    
    // Check if EmailJS is loaded
    if (typeof emailjs === 'undefined') {
      console.error('EmailJS is not loaded!');
      return false;
    }
    
    console.log('EmailJS loaded successfully');
    
    // EmailJS template parameters - Simple form data only
    const templateParams = {
      from_name: config.formData.name,
      from_phone: config.formData.phone,
      from_email: config.formData.email,
      organization: config.formData.organization || 'Not provided',
      message: `New contact form submission from ${config.formData.name}`,
      subject: config.subject,
      current_date: new Date().toLocaleString(),
    };

    // EmailJS credentials
    const serviceId = 'service_9ttrtfp';
    const templateId = 'template_q592r8m';
    const publicKey = 'e2gQjVt-ZoVl9z8kD';

    console.log('EmailJS credentials:', { serviceId, templateId, publicKey });
    console.log('Template parameters:', templateParams);
    
    // Send email via EmailJS
    console.log('Attempting to send email...');
    const result = await emailjs.send(
      serviceId,
      templateId,
      templateParams,
      publicKey
    );

    console.log('Email sent successfully:', result);
    console.log('Result status:', result.status);
    console.log('=== EMAIL SERVICE DEBUG END ===');
    return result.status === 200;
    
  } catch (error) {
    console.error('=== EMAIL SERVICE ERROR START ===');
    console.error('Error sending email:', error);
    
    if (error instanceof Error) {
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      });
    }
    
    console.error('=== EMAIL SERVICE ERROR END ===');
    return false;
  }
};

// Alternative: Simple email using mailto link (fallback option)
export const sendEmailViaMailto = (formData: ContactFormData): void => {
  const subject = encodeURIComponent('New Contact Form Submission - MedAlt');
  const body = encodeURIComponent(`
New Contact Form Submission:

Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email}
Organization: ${formData.organization || 'Not provided'}

Submitted at: ${new Date().toLocaleString()}
  `);
  
  const mailtoLink = `mailto:tejasvi.kalakota@berkeley.edu,rahul21rajendran@gmail.com?subject=${subject}&body=${body}`;
  
  window.open(mailtoLink);
}; 